import { render, staticRenderFns } from "./MainHeaderV2.vue?vue&type=template&id=c3451c50&scoped=true&"
import script from "./MainHeaderV2.vue?vue&type=script&lang=js&"
export * from "./MainHeaderV2.vue?vue&type=script&lang=js&"
import style0 from "./MainHeaderV2.vue?vue&type=style&index=0&id=c3451c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3451c50",
  null
  
)

export default component.exports